export const UTM = {
  SOURCE: "utm_source",
  MEDIUM: "utm_medium",
};
